import { render, staticRenderFns } from "./StudentRootView.vue?vue&type=template&id=5b23c286"
import script from "./StudentRootView.vue?vue&type=script&lang=js"
export * from "./StudentRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports